module.exports = __webpack_public_path__ + "img/stars-bg-mobile.a678cf7.webp";